import { Alert, Box, Button, Card, CardContent, Container, Divider, Typography } from '@mui/material';
import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const CheckoutInstructions: React.FC = () => {
  const [params] = useSearchParams();
  const method = params.get('method');
  const navigate = useNavigate();

  const isOM = method === 'om';
  const isWave = method === 'wave';

  return (
    <Container maxWidth="sm">
      <Box sx={{ py: 6 }}>
        <Card>
          <CardContent>
            <Typography variant="h5" gutterBottom>
              Payment Instructions
            </Typography>
            <Divider sx={{ my: 2 }} />
            {isOM && (
              <Alert severity="info" sx={{ mb: 2 }}>
                Please send the total amount via Orange Money to the number below. Your order will be processed once we confirm the payment.
              </Alert>
            )}
            {isWave && (
              <Alert severity="info" sx={{ mb: 2 }}>
                Please send the total amount via Wave to the number below. Your order will be processed once we confirm the payment.
              </Alert>
            )}
            {!isOM && !isWave && (
              <Alert severity="warning" sx={{ mb: 2 }}>
                No payment method specified. Please contact support if this is unexpected.
              </Alert>
            )}

            <Box sx={{ p: 2, borderRadius: 2, border: '1px dashed', borderColor: 'divider', mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">Recipient Name</Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>TotalBat</Typography>
              <Typography variant="subtitle2" color="text.secondary">Phone Number</Typography>
              <Typography variant="body1">+221 77 123 45 67</Typography>
            </Box>

            <Button variant="contained" fullWidth onClick={() => navigate('/')}>Return Home</Button>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default CheckoutInstructions;



